module.exports = "<div class=\"col-xs-12 col-sm-3 col-md-4\" style=height:100vh> <div class=row ng-show=isProgress> <loading-directive></loading-directive> </div> </div> <pre>{{ items | json }}</pre> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.item/appItemsList.html
// module id = 1041
// module chunks = 0